//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parseTime } from "@/utils";
export default {
  props: {
    city: String,
    date: Number,
  },
  computed: {
    dateText() {
      return parseTime(this.date, "{y}年{m}月");
    },
  },
  methods: {
    onCityClick() {
      this.$emit("city");
    },
    onDateClick() {
      this.$emit("date");
    },
  },
};
